// extracted by mini-css-extract-plugin
module.exports = {"TopBanner":"TopBanner_TopBanner__21Lwp","TopBannerTagline":"TopBanner_TopBannerTagline__3HpAH"};